var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetflixImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5455 0C7.74863 0 5.06635 1.11104 3.08869 3.08869C1.11104 5.06635 0 7.74863 0 10.5455V47.4545C0 50.2514 1.11104 52.9337 3.08869 54.9113C5.06635 56.889 7.74863 58 10.5455 58H47.4545C50.2514 58 52.9337 56.889 54.9113 54.9113C56.889 52.9337 58 50.2514 58 47.4545V10.5455C58 7.74863 56.889 5.06635 54.9113 3.08869C52.9337 1.11104 50.2514 0 47.4545 0H10.5455ZM40.2335 41.0587V9.22727H32.1452V18.8131L40.2335 41.0587ZM17.7691 16.2532V48.7727L25.8575 46.9747V36.2368L17.7691 16.2532ZM25.8548 9.22727H17.7665L33.0442 46.9747L40.2335 48.7727L25.8548 9.22727Z",
    fill: "url(#paint0_linear_480_12666)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_480_12666",
    x1: 21.75,
    y1: -52.2,
    x2: 80.1437,
    y2: -36.9142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509615,
    stopColor: "#E9AD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64C9B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetflixImg);
export default __webpack_public_path__ + "static/media/Netflix-img.28e301a4de0a52c6cf13e26ea51fcd5e.svg";
export { ForwardRef as ReactComponent };